import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaFileAlt } from "react-icons/fa";



export default function WebFooter() {


  return (
    <>
      <Col lg={12}>
        <div className='p-1 ' style={{ backgroundColor: '#008080' }}>
          <Container>
            <Row className='mt-3'>
              <Col lg={4}  >
                <h5 style={{ color: 'white' }}>SAMASHREE ENTERPRISES</h5>
                <p className='text-white' style={{textAlign:'justify'}}>
                Samashree Enterprises Pvt. Ltd., Nashik, Maharashtra, is a trusted provider of Security Services, Hospitality (Labor Supply), Civil Construction, Routine Maintenance, and Steel Fabrication & Erection. We are committed to quality, safety, and client satisfaction.
                
                </p>

               
              </Col>

              <Col lg={4}>
                <h5 style={{ color: 'white' }}>Contact</h5>
                <div className='mb-2 '>
                  <a
                    href="https://wa.me/7410596426 "
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span className='text-white'>
                      <FaMobileAlt color='white' />  +917410596426
                    </span>
                  </a>
                  
                </div>
                <div>
                   <span className='text-white'>
                      <FaMobileAlt color='white' />+916362514335 
                    </span>
                </div>

                <div className='d-flex '>
                  <a
                    href="mailto:info@samashreeenterprises.com "
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span className='text-white'>
                      < MdEmail color='white' />  info@samashreeenterprises.com 
                    </span>
                  </a>
                </div>
              </Col>

              <Col lg={4}>
                <h5 style={{ color: 'white' }}>Connect With us</h5>

                <div className='text-white' >
                  <FaLocationDot color='white' /> Flat No. 05, Aksharpushp Apartment, Kevadiban, Panchvati, Nashik 422003, Maharashtra, India. 
                </div>

                <div className='d-flex mt-2 '>

                  <a className='iconback' href="#">
                    <FaFacebookF />
                  </a>
                  <a className='iconback mx-2' href='#'>
                    <IoLogoYoutube />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaInstagram />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaXTwitter />
                  </a>
                </div>
              </Col>
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()} SAMASHREE ENTERPRISES PVT.LTD |
                <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a> </p>
            </div>
          </Container>
        </div>
      </Col>
    </>
  )
}
